import React from "react";
import PropTypes from "prop-types";
import ItemList from "../components/ItemList.jsx";

export default class PersonCard extends React.Component {
  constructor(props) {
    super(props);

    this.itemWrapper = null;
  }

  componentDidUpdate() {
    const { index, loading } = this.props;

    if (0 == index && !loading) {
      this.itemWrapper.focus();
    }
  }

  render() {
    const { abstract, programs, projects, title, type, universityaffiliation, url } = this.props;

    const ariaLabel = "Read the full article on " + title;

    return (
      <div className="digest-card">
        { title && <div className="digest-card__title"><a ref={el => (this.itemWrapper = el)} href={ url }>{ title }{ universityaffiliation && <span>, { universityaffiliation }</span> }</a></div>}
        { programs && programs.length > 0 && <ItemList items={programs} label="Program(s)" /> }
        { projects && projects.length > 0 && <ItemList items={projects} label="Project(s)" /> }
        { abstract && <div className="digest-card__summary">{ abstract }...</div>}
      </div>
    );
  }
}

const { array, bool, func, number, object, string } = PropTypes;

PersonCard.propTypes= {
  abstract: string,
  index: number,
  loading: bool,
  programs: array,
  projects: array,
  title: string,
  type: string,
  universityaffiliation: string,
  url: string
};
